<template>
  <v-dialog
    v-model="showPopup"
    persistent
    max-width="520"
    @keydown.passive.enter='doSave'
    @keydown.passive.esc='$emit("cancel")'
  >
    <v-card class="pa-4">
      <v-card-title class="headline justify-center popup-title">
        Barcode Label
      </v-card-title>
      <v-card-text>
        <div class="home-content pt-4 pb-4" style="max-width: 300px; margin: 0 auto">
          <v-row v-if="getBarcode">
            <v-col>
              <div class="bin-barcode">
                <img :src="getBarcode" width="200" />
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="label-text">Choose label size</span>
              <div class="input-mb input-box">
                <v-select
                  v-model="size"
                  :items="sizeItems"
                  item-text="title"
                  item-value="value"
                  return-object
                  single-line
                  class="r-field general-settings-select mr-0"
                />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions class="text-xs-center justify-center">
        <v-btn
          @click="$emit('cancel')"
          depressed
          class="cancel-btn small-size"
        >
          Cancel
        </v-btn>
        <v-btn
          @click="doSave"
          depressed
          class="save-btn small-size"
          min-width='160'
        >
          Save as pdf
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'WarehouseMapBarcodeSettingsPopup',
  props: {
    showPopup: {
      type: Boolean,
      required: true
    },
    item: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      size: { title: 'medium 4 x 2 in', value: 'medium' },
      sizeItems: [
        { title: 'extra large 5½ x 8½ in', value: 'extralarge' },
        { title: 'large 3 ⅓  x 4 in', value: 'large' },
        { title: 'medium 4 x 2 in', value: 'medium' },
        { title: 'medium tall 2 x 4 in', value: 'mediumtall' },
        { title: 'small 4 x 1⅓ in', value: 'small' },
        { title: 'extra small 2⅝x 1 in', value: 'extrasmall' },
        { title: 'micro 1 x 1 in', value: 'micro' }
      ]
    }
  },
  methods: {
    async doSave() {
      this.$emit('save', { size: this.size.value })
    }
  },
  computed: {
    getBarcode() {
      return this.item?.original?.barcode || ''
    }
  }
}
</script>

<style scoped lang="scss">
.bin-barcode {
  width: 100%;
  height: 120px;
  padding: 15px;
  border-radius: 10px;
  background-color: #ffffff;
  border: 1px solid rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
}
</style>
